module.exports = window.wp.isShallowEqual;